import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import StraightenIcon from '@mui/icons-material/Straighten'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/system'
import KNAttribute from 'components/KNAttribute/KNAttribute'
import { KNVolumeIcon, KNWeightIcon } from 'components/KNIcon/KNMaterialIcon'
import { GuestUserContext } from 'context/authentication/GuestUserContext'
import {
  getLoadingMetersMeasurement,
  getLoadingMetersUnit,
  getVolumeMeasurement,
  getVolumeUnit,
  getWeightMeasurement,
  getWeightUnit,
} from 'global/helpers/units'
import { type ReactElement, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import type { QuoteRequest } from 'screens/QuoteDetails/QuoteDetails.types'
import type { QuoteTotals } from './Quotes.types'

export interface QuoteCargoProps {
  quoteRequest: QuoteRequest
  sx?: SxProps
}

export const getQuoteCargoTotals = (quoteRequest: QuoteRequest): QuoteTotals =>
  quoteRequest.shipments.reduce((totals, shipment) =>
    shipment.cargoItems.reduce((shipmentTotals, cargo) => ({
      weight: shipmentTotals.weight + (cargo.grossWeight ?? 0),
      volume: shipmentTotals.volume + (cargo.volume ?? 0),
      loadingMeters: shipmentTotals.loadingMeters + (cargo.loadingMeters ?? 0),
    }), totals),
  { weight: 0, volume: 0, loadingMeters: 0 })

const QuoteCargo = ({ quoteRequest, sx }: QuoteCargoProps): ReactElement => {
  const { t } = useTranslation()
  const [guestUserState, _guestUserDispatch] = useContext(GuestUserContext)
  const totals = getQuoteCargoTotals(quoteRequest)

  return (
    <Stack direction="row" alignItems="start" sx={{ ...sx, flexWrap: 'wrap', columnGap: 1, rowGap: 0.5 }}>
      <KNAttribute
        value={t('screens.cs.quotes.card.shipments_count', { count: quoteRequest.shipments.length })}
        icon={<Inventory2OutlinedIcon />}
      />
      <KNAttribute
        value={getWeightMeasurement(totals.weight, guestUserState.measurementsSystem)}
        suffix={getWeightUnit(guestUserState.measurementsSystem)}
        icon={<KNWeightIcon />}
      />
      <KNAttribute
        value={getVolumeMeasurement(totals.volume, guestUserState.measurementsSystem)}
        suffix={getVolumeUnit(guestUserState.measurementsSystem)}
        icon={<KNVolumeIcon />}
      />
      <KNAttribute
        value={getLoadingMetersMeasurement(totals.loadingMeters, guestUserState.measurementsSystem)}
        suffix={getLoadingMetersUnit(guestUserState.measurementsSystem)}
        icon={<StraightenIcon />}
      />
    </Stack>
  )
}

export default QuoteCargo



